module.exports = __webpack_public_path__ + "img/tts.024970d8.png";